import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Fade,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import popupImage from "/alertpopup.png";

// Clave única para localStorage - cambiar si se quiere resetear para todos los usuarios
const POPUP_STORAGE_KEY = "alerta_estafa_v2";

/**
 * AnnouncementPopup - Popup de anuncio con opción de no volver a mostrar
 *
 * Muestra un popup con una imagen de anuncio al entrar a la página.
 * El usuario puede marcar "No volver a mostrar" para que no aparezca de nuevo.
 * Esta preferencia se guarda en localStorage.
 */
const AnnouncementPopup = () => {
  const [open, setOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  // Verificar si el usuario ya marcó "no volver a mostrar"
  useEffect(() => {
    const isDismissed = localStorage.getItem(POPUP_STORAGE_KEY);

    if (!isDismissed) {
      // Pequeño delay para que no aparezca inmediatamente al cargar
      const timer = setTimeout(() => {
        setOpen(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    // Si el usuario marcó "no volver a mostrar", guardar en localStorage
    if (dontShowAgain) {
      localStorage.setItem(POPUP_STORAGE_KEY, "true");
    }
    setOpen(false);
  };

  const handleDontShowAgainChange = (event) => {
    setDontShowAgain(event.target.checked);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Fade}
      transitionDuration={300}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
          maxWidth: { xs: "95%", sm: "50vh" },
          margin: { xs: 1, sm: 2 },
        },
      }}
    >
      <DialogContent sx={{ p: 0, position: "relative" }}>
        {/* Botón de cerrar */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            color: "#004b93",
            zIndex: 10,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 1)",
              transform: "scale(1.1)",
            },
            transition: "all 0.2s ease",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
          size="small"
        >
          <Close />
        </IconButton>

        {/* Imagen del anuncio */}
        <Box
          component="img"
          src={popupImage}
          alt="Nuevos horarios de atención - Lunes a Viernes: 10:00 a 19:00 hrs, Sábados: 10:00 a 14:00 hrs"
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />

        {/* Checkbox para no volver a mostrar */}
        <Box
          sx={{
            p: 2,
            backgroundColor: "#f5f5f5",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={dontShowAgain}
                onChange={handleDontShowAgainChange}
                sx={{
                  color: "#004b93",
                  "&.Mui-checked": {
                    color: "#004b93",
                  },
                }}
              />
            }
            label={
              <Typography variant="body2" color="text.secondary">
                No volver a mostrar este anuncio
              </Typography>
            }
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AnnouncementPopup;
